<template>
  <div
    :style="{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      paddingRight: '2px',
      paddingLeft: '2px',
      color: corTexto,
    }"
  >
    <div
      id="telaCarregamento"
      class="telaCarregamento"
      :class="{
        aberto: telaCarregamento === 'aberto',
        fechado: telaCarregamento === 'fechado',
      }"
    >
      <div
        class="spinner-border"
        style="width: 3.5rem; height: 3.5rem"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          text-align: center;
          align-items: center;
        "
      >
        <h1>Realizando seu pedido...</h1>
        <span>O processo do pedido pode demorar um pouco.</span>
      </div>
    </div>
    <div
      style="display: flex; justify-content: center; flex-direction: column"
      class="app"
    >
      <button
        :style="{
          alignItems: 'center',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto,
        }"
        class="btn btn-dark"
      >
        Forma de pagamento
      </button>
    </div>
    <br />

    <div class="radio-tabs">
      <input
        type="radio"
        name="payment"
        id="site"
        class="radio-input"
        checked
      />
      <label class="radio-label">Pagamento pelo Site</label>
    </div>

    <div
      v-if="
        plataformaCartao === '' && plataformaPix === '' && metodosOnline === ''
      "
      class="spinner-border"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>

    <section style="display: flex; justify-content: space-between">
      <ul style="display: flex; flex-direction: column">
        <li style="display: flex; align-items: center" key="credito">
          <input
            type="radio"
            id="credito"
            value="credito-online"
            v-model="pagamento"
          />
          <label style="padding-left: 10px" for="credito"
            >Cartão de Crédito</label
          >
        </li>
        <li style="display: flex; align-items: center" key="pix">
          <input type="radio" id="pix" value="pix-online" v-model="pagamento" />
          <label style="padding-left: 10px" for="pix">Pix</label>
        </li>
      </ul>
    </section>

    <br />

    <section
      v-if="
        pagamento === 'pix-online' &&
        (plataformaPix === 'asaas' || plataformaPix === 'paggpix')
      "
      style="
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <h5 style="text-align: center">
        Você será redirecionando a tela de pagamento após finalizar o pedido.
      </h5>
    </section>

    <div
      style="display: flex; justify-content: center; flex-direction: column"
      class="app"
      v-if="pagamento === 'credito-online' && plataformaCartao === 'asaas'"
    >
      <button
        :style="{
          alignItems: 'center',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto,
        }"
        class="btn btn-dark"
      >
        Pagamento por Cartão de Crédito
      </button>
    </div>

    <section
      v-if="pagamento === 'credito-online' && plataformaCartao === 'asaas'"
      style="
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      "
    >
      <h4 style="margin: 12px 0">Informações do Cartão</h4>
      <div class="infoBandeira">
        <span>Aceitamos:</span>
        <div class="bandeiras">
          <img
            src="img/bandeiras/flat-rounded/visa.svg"
            alt="Bandeira de cartão Visa"
          />
          <img
            src="img/bandeiras/flat-rounded/mastercard.svg"
            alt="Bandeira de cartão MasterCard"
          />
          <img
            src="img/bandeiras/flat-rounded/elo.svg"
            alt="Bandeira de cartão ELO"
          />
          <img
            src="img/bandeiras/flat-rounded/discover.svg"
            alt="Bandeira de cartão Discover"
          />
          <img
            src="img/bandeiras/flat-rounded/amex.svg"
            alt="Bandeira de cartão American Express"
          />
        </div>
      </div>
      <label for="holderName">Nome do Títular do Cartão</label>
      <input
        type="text"
        id="holderName"
        v-model="cartao.cardInfo.holderName"
        class="form-control"
        placeholder="João da Silva"
      />
      <label for="numberCard">Número do Cartão</label>
      <input
        type="text"
        id="numberCard"
        v-model="cartao.cardInfo.number"
        class="form-control"
        placeholder="0000 0000 0000 0000"
        v-cleave="{ creditCard: true, onCreditCardTypeChanged: cardChanged }"
      />
      <label for="expiryDate">Data de Vencimento do Cartão</label>
      <input
        type="text"
        id="expiryDate"
        v-model="cartao.cardInfo.expiryDate"
        class="form-control"
        placeholder="MM/AA"
        v-cleave="{ date: true, datePattern: ['m', 'y'] }"
      />
      <label for="cvvCartao">CVV (Código de Segurança do Cartão)</label>
      <input
        type="text"
        id="cvvCartao"
        v-model="cartao.cardInfo.cvv"
        class="form-control"
        placeholder="000"
        v-cleave="{ numericOnly: true, blocks: [4] }"
      />
      <h4 style="margin: 12px 0">Informações do Títular do Cartão</h4>
      <div style="margin-bottom: 12px; display: flex; flex-direction: row">
        <input type="checkbox" id="checkSameAsUser" v-model="sameAsUser" />
        <label style="padding-left: 10px" for="checkSameAsUser"
          >O títular do cartão e o usuário do pedido são a mesma pessoa?</label
        >
      </div>
      <div v-if="!sameAsUser" style="display: flex; flex-direction: column">
        <label for="nome">Nome Completo</label>
        <input
          type="text"
          id="nome"
          v-model="cartao.cardHolderInfo.name"
          class="form-control"
          placeholder="João da Silva"
        />
        <label for="email">Email</label>
        <input
          type="text"
          id="email"
          v-model="cartao.cardHolderInfo.email"
          class="form-control"
          placeholder="joao@gmail.com"
        />
        <label for="phone">Telefone</label>
        <input
          type="text"
          id="phone"
          v-model="cartao.cardHolderInfo.phone"
          class="form-control"
          placeholder="00 00000-0000"
          v-cleave="{ phone: true, phoneRegionCode: 'BR' }"
        />
        <label for="cpfCnpj">CPF (Cadastro de Pessoa Física)</label>
        <input
          type="text"
          id="cpfCnpj"
          v-model="cartao.cardHolderInfo.cpfCnpj"
          class="form-control"
          placeholder="000.000.000-00"
          v-cleave="{
            numericOnly: true,
            delimiters: ['.', '.', '-'],
            blocks: [3, 3, 3, 2],
          }"
        />
      </div>
      <div style="display: flex; flex-direction: column">
        <label for="postalCode">CEP (Código de Endereçamento Postal)</label>
        <input
          type="text"
          id="postalCode"
          v-model="cartao.cardHolderInfo.postalCode"
          class="form-control"
          placeholder="00000-000"
          v-cleave="{
            numericOnly: true,
            delimiter: '-',
            blocks: [5, 3],
          }"
        />
        <label for="addressNumber">Número do Endereço</label>
        <input
          type="text"
          id="addressNumber"
          v-model="cartao.cardHolderInfo.addressNumber"
          class="form-control"
          placeholder="123"
        />
        <label for="addressComplement">Complemento (Opcional)</label>
        <input
          type="text"
          id="addressComplement"
          v-model="cartao.cardHolderInfo.addressComplement"
          class="form-control"
          placeholder="Casa"
        />
      </div>
    </section>
    <br />
    <div style="display: flex; align-items: center; justify-content: flex-end">
      <label>Valor total: R$ {{ total.toFixed(2) }}</label>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #8b0000;
      "
    >
      <div
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <button
          style="
            align-items: center;
            margin-top: 5px;
            margin-bottom: 5px;
            margin-right: 5px;
            background-color: #dc3545;
          "
          class="btn btn-dark"
          @click="pushSair()"
        >
          Sair
        </button>
      </div>
      <button
        style="
          align-items: center;
          margin-top: 5px;
          margin-bottom: 5px;
          background-color: #006400;
        "
        :disabled="isDisabled"
        class="btn btn-dark"
        @click="salvarVenda(products)"
      >
        Finalizar pedido
      </button>
    </div>
  </div>
</template>
<style>
.botao {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}
.custom-datetime {
  padding: 10px;
  border: 2px solid #545454; /* Borda azul */
  border-radius: 5px; /* Arredondar os cantos */
  font-size: 16px; /* Tamanho da fonte */
  color: #545454; /* Cor do texto */
  background-color: #f0f0f0; /* Fundo mais claro */
  transition: border-color 0.3s, box-shadow 0.3s; /* Suavizar a transição de borda e sombra */
}

.custom-datetime:focus {
  border-color: #545454; /* Borda azul mais escura ao focar */
  box-shadow: 0 0 5px rgba(84, 84, 84, 0.5); /* Sombra ao focar */
  outline: none; /* Remover contorno padrão */
}

.custom-datetime::-webkit-calendar-picker-indicator {
  background-color: #f0f0f0; /* Cor do ícone do calendário */
  padding: 5px;
  border-radius: 50%;
}

.radio-tabs {
  display: flex;
  border-bottom: 1px solid #ccc;
  margin-bottom: 25px;
}

.radio-input {
  display: none;
}

.radio-label {
  font-size: 1rem;
  font-weight: 500;
  color: #777;
  cursor: pointer;
  padding: 10px 10px;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease-in-out;
}

.radio-input:checked + .radio-label {
  color: #333;
  font-weight: bold;
  border-bottom: 2px solid #333;
}

.telaCarregamento {
  position: fixed;
  height: 100dvh;
  width: 100dvw;
  top: 0;
  left: 0;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  z-index: 9999;
  gap: 12px;
}

.telaCarregamento.aberto {
  display: flex;
  animation: fade-in 0.4s forwards;
}

.telaCarregamento.fechado {
  display: none;
  animation: fade-out 0.4s forwards;
}

@keyframes fade-in {
  from {
    display: flex;
    opacity: 0;
  }

  to {
    display: flex;
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    display: flex;
    opacity: 1;
  }

  to {
    display: flex;
    opacity: 0;
  }
}

.infoBandeira {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
  gap: 6px;
}

.bandeiras {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.bandeiras img {
  height: 25px;
  aspect-ratio: 2/1;
}

.divFormControl {
  display: block;
  width: 100%;
  padding: 0.25rem 0.2rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #495057;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  height: calc(1.5em + 0.75rem + 2px);
}

.divFormControl input {
  all: unset;
  height: 100%;
}

.divFormControl span {
  margin: 0 4px;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import creditCardType from "credit-card-type";
import Inis from "../services/inis";
// import Usuario from "../services/usuario";
import Swal from "sweetalert2";
import api from "../services/api";
import axios from "axios";

export default {
  name: "Pagamento",
  data() {
    return {
      msgEntrega: "",
      msgRetirada: "",
      msgBuscaFone: "",
      estado: "",
      cidade: "",
      bairro: "",
      rua: "",
      numero: "",
      complemento: "",
      referencia: "",
      cep: "",
      latitude: "",
      longitude: "",
      LatLoja: "",
      LonLoja: "",
      distanciaUsuario: "",
      tipoEntrega: "",
      enderecos: {},
      raio: {},
      usuarios: [],
      cd: "",
      tipoPagamento: "entrega",
      pagamento: "",
      checkedEndereco: "",
      taxa: "",
      telaCarregamento: "",
      endereco_cd: "",
      inis_valores: [],
      inis_valor: [],
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      vendaspedidos: [],
      vendas: [],
      venda: {
        cd: "",
        total: "",
        dt: "",
        cd_usu: "",
        status: "",
        forma: "",
        troco: "",
        taxa: "",
        vl_desc: "",
      },
      corBotao: "",
      corTexto: "",
      corFundo: "",
      nomecompleto: "",
      valorDinheiro: "",
      valorTotal: "",
      valorTroco: 0,
      retirarBoolean: false,
      retirarLocalInis: true,
      somenteRetirada: false,
      valorMinimo: 0,
      cupom: "",
      cupomAprovado: "",
      desconto: {},
      jaUsado: "",
      quantidade: "",
      estoque: "",
      quantidadeInvalida: false,
      qtd: [],
      quantidadeArray: [],
      cupomAux: "",
      cupomAtivado: false,
      bandeiras: [],
      spinnerEndereco: true,
      spinnerCartao: true,
      win: "",
      idPixel: "",
      cadastro: "",
      cel: "",
      possuiAsaas: false,
      plataformaCartao: "",
      plataformaPix: "",
      isDisabled: false,
      dataAgendamento: "",
      cdAgendamento: -1,
      checkedAgendamento: [],
      mercadoPagoCarregado: false,
      minDateTime: "",
      valorBase: 0,
      sameAsUser: true,
      contrato: "",
      cartao: {
        cardInfo: {
          holderName: "",
          number: "",
          expiryDate: "",
          expiryMonth: "",
          expiryYear: "",
          cvv: "",
        },
        cardHolderInfo: {
          sameAsUser: "",
          name: "",
          email: "",
          cpfCnpj: "",
          postalCode: "",
          addressNumber: "",
          addressComplement: "",
          phone: "",
        },
      },
      cursorPosMonthAnterior: 0,
      cursorPosYearAnterior: 0,
    };
  },
  computed: {
    retornaContrato() {
      this.contrato = parseInt(process.env.VUE_APP_CONTRATO);

      return this.contrato;
    },
    ...mapGetters({
      nome: "retornaNome",
      cpf: "retornaCPF",
      email: "retornaEmail",
      telefone: "retornaTelefone",
      total: "retornaTotal",
      products: "cartProducts",
    }),
  },
  methods: {
    showTelaCarregamento(aberto) {
      if (aberto) {
        this.telaCarregamento = "aberto";
      } else {
        this.telaCarregamento = "fechado";
      }
    },
    listarInisValorMinimo() {
      var cd = "VL_MIN_PEDIDO";
      Inis.listarInisCd(cd).then((resposta) => {
        this.valorMinimo = resposta.data[0].vl;
      });
    },
    //listarinisvalores
    listarinisvalores() {
      Inis.listarinisvalores().then((resposta) => {
        this.inis_valores = resposta.data;
        //alert(resposta.data);
      });
    },
    //listarinis
    async listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis_valor = resposta.data;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corTexto = resposta.data[0].vl;
      });
      var cd = "TIPO_LOGIN";
      Inis.listarInisCd(cd).then((resposta) => {
        this.cadastro = resposta.data[0].vl;
      });
      await Inis.listarInisCd("POSSUI_ASAAS").then((resposta) => {
        this.possuiAsaas = resposta.data[0].vl === "1" ? true : false;
      });
      await Inis.listarInisCd("PLATAFORMA_CARTAO").then((resposta) => {
        this.plataformaCartao = resposta.data[0].vl;
      });
      await Inis.listarInisCd("PLATAFORMA_PIX").then((resposta) => {
        this.plataformaPix = resposta.data[0].vl;
      });
    },
    async salvarVenda(products) {
      try {
        this.isDisabled = true;
        if (!(await this.validarCampos())) {
          this.isDisabled = false;
          return false;
        }

        var v = new Object();

        v.contrato = this.retornaContrato;
        v.cliente = {
          nm: this.nome,
          cpf: this.cpf.replaceAll(/[\D]/g, ""),
          email: this.email,
          fone: this.telefone.replaceAll(/[\D]/g, ""),
        };
        v.forma = this.pagamento;
        v.mesa = this.$store.state.mesa;
        v.serie = this.$store.state.serie;
        v.num_serie = this.$store.state.num_serie;
        v.cartao = {
          cardInfo: {
            holderName: this.cartao.cardInfo.holderName,
            number: this.cartao.cardInfo.number.replaceAll(/[\D]/g, ""),
            expiryDate: this.cartao.cardInfo.expiryDate,
            expiryMonth: this.cartao.cardInfo.expiryDate.split("/")[0],
            expiryYear: this.cartao.cardInfo.expiryDate.split("/")[1],
            cvv: this.cartao.cardInfo.cvv.replaceAll(/[\D]/g, ""),
          },
          cardHolderInfo: {
            sameAsUser: this.sameAsUser ? "1" : "0",
            idAddress:
              this.endereco_cd !== "retirarLocal" && this.endereco_cd !== ""
                ? this.enderecos[this.endereco_cd].cd
                : null,
            name: this.cartao.cardHolderInfo.name,
            email: this.cartao.cardHolderInfo.email,
            cpfCnpj: this.cartao.cardHolderInfo.cpfCnpj.replaceAll(/[\D]/g, ""),
            postalCode: this.cartao.cardHolderInfo.postalCode.replaceAll(
              /[\D]/g,
              ""
            ),
            addressNumber: this.cartao.cardHolderInfo.addressNumber.replaceAll(
              /[\D]/g,
              ""
            ),
            addressComplement: this.cartao.cardHolderInfo.addressComplement,
            phone: this.cartao.cardHolderInfo.phone.replaceAll(/[\D]/g, ""),
          },
        };

        if (
          this.plataformaCartao === "asaas" &&
          this.pagamento === "credito-online" &&
          !(await this.validarCamposCartao(v.cartao))
        ) {
          this.isDisabled = false;
          return false;
        }

        v.products = products.map((produto) => {
          if (produto.unitario == "0") {
            produto.quantity = produto.peso;
          }
          return produto;
        });

        let responsePix;

        this.showTelaCarregamento(true);

        if (this.pagamento === "credito-online") {
          try {
            await api.post("/qrcode/carrinho", {
              contrato: v.contrato,
              cliente: v.cliente,
              forma: v.forma,
              mesa: v.mesa,
              serie: v.serie,
              num_serie: v.num_serie,
              cartao: v.cartao,
              products: v.products,
            });
          } catch (err) {
            if (axios.isAxiosError(err)) {
              Swal.fire({
                icon: "error",
                title: "Erro ao realizar o pagamento!",
                text: err.response.data.error ? err.response.data.error : null,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erro ao realizar o pagamento!",
              });
            }
            throw new Error();
          }
        } else if (this.pagamento === "pix-online") {
          try {
            responsePix = await api.post("/qrcode/carrinho", {
              contrato: v.contrato,
              cliente: v.cliente,
              forma: v.forma,
              mesa: v.mesa,
              serie: v.serie,
              num_serie: v.num_serie,
              products: v.products,
            });
          } catch (err) {
            if (axios.isAxiosError(err)) {
              Swal.fire({
                icon: "error",
                title: "Erro ao finalizar o pedido!",
                text: err.response.data.error ? err.response.data.error : null,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erro ao finalizar o pedido!",
              });
            }
            throw new Error();
          }
        }

        if (this.pagamento === "pix-online") {
          localStorage.setItem("token-pix", responsePix.data.token);
          this.$store.commit("setPagamentoPix", {
            id: responsePix.data.id,
            date: responsePix.data.expira,
            payload: responsePix.data.chave,
            valor: responsePix.data.total,
          });
          this.$store.commit("setNome", "");
          this.$store.commit("setCPF", "");
          this.$store.commit("setEmail", "");
          this.$store.commit("setTelefone", "");
          this.$store.commit("setZera", []);
          this.$router.push("/pagamentopix");
        } else {
          Swal.fire({
            title: "Pedido realizado com sucesso!",
            text: "Seu pedido foi realizado e aprovado com sucesso.",
            confirmButtonColor: "#000000",
          });

          this.$store.commit("setNome", "");
          this.$store.commit("setCPF", "");
          this.$store.commit("setEmail", "");
          this.$store.commit("setTelefone", "");
          this.$store.commit("setZera", []);
          this.$router.push("/");
        }
      } catch (err) {
        console.log(err);
        this.isDisabled = false;
        this.showTelaCarregamento(false);
      }
    },
    async validarCampos() {
      const campos = [
        {
          condicao: this.pagamento === "",
          mensagem: "Por favor, selecione forma de pagamento.",
        },
        {
          condicao: this.total === "0.00",
          mensagem: "Por favor, selecione um produto.",
        },
        {
          condicao: parseFloat(this.valorMinimo) > parseFloat(this.total),
          mensagem: `O valor mínimo de compra é: R$ ${String(
            parseFloat(this.valorMinimo).toFixed(2).replaceAll(".", ",")
          )} reais`,
        },
      ];

      for (const { condicao, mensagem } of campos) {
        if (condicao) {
          await Swal.fire({
            title: mensagem,
            confirmButtonColor: "#000000",
          });
          return false;
        }
      }

      // Se todos os campos forem válidos, retorne true
      return true;
    },
    validarNumeroCartao(cardNumber) {
      if (!cardNumber) return false;
      if (!/^\d{15,16}$/.test(cardNumber)) return false;

      var nCheck = 0,
        nDigit = 0,
        bEven = false;
      cardNumber = cardNumber.replace(/\D/g, "");

      for (var n = cardNumber.length - 1; n >= 0; n--) {
        var cDigit = cardNumber.charAt(n),
          nDigit = parseInt(cDigit, 10);

        if (bEven) {
          if ((nDigit *= 2) > 9) nDigit -= 9;
        }

        nCheck += nDigit;
        bEven = !bEven;
      }

      return nCheck % 10 == 0;
    },
    validarBandeiraCartao(cardNumber) {
      if (!cardNumber) return false;
      const bandeira = creditCardType(cardNumber)[0].type;
      if (
        !["visa", "mastercard", "elo", "discover", "american-express"].includes(
          bandeira
        )
      )
        return false;
      return true;
    },
    validarCvvCartao(cardNumber, cvv) {
      if (!cardNumber || !cvv) return false;
      if (!/^\d+$/.test(cvv)) return false;

      const bandeira = creditCardType(cardNumber)[0].type;

      if (bandeira === "american-express")
        if (cvv.length !== 4) return false;
        else if (cvv.length !== 3) return false;

      return true;
    },
    validarCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, "");

      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
        return false;
      }

      let soma = 0;
      for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let resto = 11 - (soma % 11);
      let digito1 = resto >= 10 ? 0 : resto;

      soma = 0;
      for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
      }
      resto = 11 - (soma % 11);
      let digito2 = resto >= 10 ? 0 : resto;

      return (
        digito1 === parseInt(cpf.charAt(9)) &&
        digito2 === parseInt(cpf.charAt(10))
      );
    },
    async validarCamposCartao(cartao) {
      const dados = [
        {
          condicao: cartao.cardInfo.holderName === "",
          mensagem: "Digite o nome do títular do cartão",
        },
        {
          condicao: cartao.cardInfo.holderName.length > 60,
          mensagem: "O nome do títular só pode até 60 letras",
        },
        {
          condicao: cartao.cardInfo.number === "",
          mensagem: "Digite o número do cartão",
        },
        {
          condicao: !this.validarNumeroCartao(cartao.cardInfo.number),
          mensagem: "O número do cartão digitado é inválido",
        },
        {
          condicao: !this.validarBandeiraCartao(cartao.cardInfo.number),
          mensagem: "Não aceitamos a bandeira do seu cartão",
        },
        {
          condicao: cartao.cardInfo.expiryDate === "",
          mensagem: "A data de expiração está inválida",
        },
        {
          condicao: !/^(0?[1-9]|1[0-2])$/.test(
            cartao.cardInfo.expiryDate.split("/")[0]
          ),
          mensagem: "A data de expiração está inválida",
        },
        {
          condicao:
            !/^(202[5-9]|20[3-9][0-9]|2[1-9][0-9]{2}|[3-9][0-9]{3}|2[5-9]|[3-9][0-9])$/.test(
              cartao.cardInfo.expiryDate.split("/")[1]
            ),
          mensagem: "A data de expiração está inválida",
        },
        {
          condicao: cartao.cardInfo.cvv === "",
          mensagem: "Digite o CVV do cartão",
        },
        {
          condicao: !this.validarCvvCartao(
            cartao.cardInfo.number,
            cartao.cardInfo.cvv
          ),
          mensagem: "O CVV do cartão é inválido",
        },
        {
          condicao: cartao.cardHolderInfo.postalCode === "",
          mensagem: "Digite o CEP do endereço",
        },
        {
          condicao: !/^\d{8}$/.test(cartao.cardHolderInfo.postalCode),
          mensagem: "O CEP do endereço é inválido",
        },
        {
          condicao: cartao.cardHolderInfo.addressNumber === "",
          mensagem: "Digite o número do endereço",
        },
        {
          condicao: !/^\d{1,5}$/.test(cartao.cardHolderInfo.addressNumber),
          mensagem: "O número do endereço é inválido",
        },
        {
          condicao:
            cartao.cardHolderInfo.addressComplement !== "" &&
            !/^.{1,100}$/.test(cartao.cardHolderInfo.addressComplement),
          mensagem: "O complemento só pode ser até 60 caracteres",
        },
      ];

      const dadosUsuario = [
        {
          condicao: cartao.cardHolderInfo.name === "",
          mensagem: "Digite o nome do títular do cartão",
        },
        {
          condicao: cartao.cardHolderInfo.name.length > 120,
          mensagem: "O nome do títular só pode até 60 letras",
        },
        {
          condicao: cartao.cardHolderInfo.email === "",
          mensagem: "Digite o email do títular",
        },
        {
          condicao:
            !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
              cartao.cardHolderInfo.email
            ),
          mensagem: "O email do títular é inválido",
        },
        {
          condicao: cartao.cardHolderInfo.cpfCnpj === "",
          mensagem: "Digite o CPF do títular",
        },
        {
          condicao: !this.validarCPF(cartao.cardHolderInfo.cpfCnpj),
          mensagem: "O CPF do títular é inválido",
        },
        {
          condicao: cartao.cardHolderInfo.phone === "",
          mensagem: "Digite o telefone do títular",
        },
        {
          condicao: !/^\d{2}(9\d{8}|\d{8})$/.test(cartao.cardHolderInfo.phone),
          mensagem: "O telefone do títular é inválido",
        },
      ];

      const array = [
        ...dados,
        ...(cartao.cardHolderInfo.sameAsUser === "0" ? dadosUsuario : []),
      ];

      for (const { condicao, mensagem } of array) {
        if (condicao) {
          await Swal.fire({
            title: mensagem,
          });
          return false;
        }
      }

      return true;
    },
  },
  watch: {
    cartao: {
      handler(valor) {
        const valorAntigo = this.cartaoAnterior;

        if (
          !/^\d{1,2}$/g.test(valor.cardInfo.expiryMonth) &&
          valor.cardInfo.expiryMonth !== ""
        ) {
          this.cartao.cardInfo.expiryMonth =
            valorAntigo?.cardInfo.expiryMonth || "";
        }

        if (
          !/^\d{1,4}$/g.test(valor.cardInfo.expiryYear) &&
          valor.cardInfo.expiryYear !== ""
        ) {
          this.cartao.cardInfo.expiryYear =
            valorAntigo?.cardInfo.expiryYear || "";
        }

        this.cartaoAnterior = JSON.parse(JSON.stringify(valor));
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    try {
      this.listarInisValorMinimo();
      await this.listarinis();
      this.listarinisvalores();
    } catch (err) {
      console.error(err);
    }
  },
};
</script>
